import { render } from "./EventviewHeaderMatchResults.vue?vue&type=template&id=0e742d48"
import script from "./EventviewHeaderMatchResults.vue?vue&type=script&lang=js"
export * from "./EventviewHeaderMatchResults.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__